import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { Lightbulb, Sparkles, Crown, Layers } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <LegalLayout title="About Facade Lighting Studio" lastUpdated="February 26, 2026">
      <p className="text-lg text-slate-300">
        A web app that lets architects, lighting designers, and creative professionals simulate stunning architectural
        lighting effects on real building photographs — without specialized software, plugins, or 3D modeling.
      </p>

      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-4 my-6">
        <div className="bg-slate-800/60 border border-slate-700 rounded-xl p-5">
          <Lightbulb className="w-6 h-6 text-amber-400 mb-2" />
          <h3 className="text-white font-semibold mb-1">Realistic lighting simulation</h3>
          <p className="text-sm text-slate-400">
            Beam, grazer, neon, and freeform lights with surface bounce, hazy edges, and presentation-mode comparisons.
          </p>
        </div>
        <div className="bg-slate-800/60 border border-slate-700 rounded-xl p-5">
          <Sparkles className="w-6 h-6 text-amber-400 mb-2" />
          <h3 className="text-white font-semibold mb-1">AI Finalize</h3>
          <p className="text-sm text-slate-400">
            One-click hyper-realistic enhancement using Google Gemini's image-to-image model — adds bloom, shadows, and
            atmospheric scatter.
          </p>
        </div>
        <div className="bg-slate-800/60 border border-slate-700 rounded-xl p-5">
          <Layers className="w-6 h-6 text-amber-400 mb-2" />
          <h3 className="text-white font-semibold mb-1">Occluders &amp; masks</h3>
          <p className="text-sm text-slate-400">
            Rectangular and freehand polygon occluders so lights wrap correctly around columns, soffits, and balconies.
          </p>
        </div>
        <div className="bg-slate-800/60 border border-slate-700 rounded-xl p-5">
          <Crown className="w-6 h-6 text-amber-400 mb-2" />
          <h3 className="text-white font-semibold mb-1">Pro export</h3>
          <p className="text-sm text-slate-400">
            Watermark-free exports, presentation mode, batch PDF for client decks, and HD export for print.
          </p>
        </div>
      </div>

      <h2>Who it's for</h2>
      <ul>
        <li>Architects pitching night-time facade designs to clients</li>
        <li>Lighting designers prototyping fixture placement before site visits</li>
        <li>Real-estate marketers visualizing illuminated builds for brochures</li>
        <li>Event and stage designers planning architectural projection</li>
      </ul>

      <h2>How it works</h2>
      <ol className="list-decimal pl-5 space-y-1">
        <li>Upload a daytime photo of any building or facade.</li>
        <li>Place beams, neon strips, and grazers on the canvas. Drag, rotate, recolor.</li>
        <li>Toggle ambient lighting from daylight to dusk to night.</li>
        <li>(Pro) Click "Finalize with AI" for photorealistic bloom and atmosphere.</li>
        <li>Export as PNG or batch PDF for client presentations.</li>
      </ol>

      <h2>Pricing</h2>
      <p>
        Free for hobbyists. Pro starts at <strong>$2.99/month</strong> with a yearly discount.
        See full details on the <Link to="/pricing">pricing page</Link>.
      </p>

      <h2>Get in touch</h2>
      <p>
        Questions, partnerships, or media inquiries — visit <Link to="/contact">our contact page</Link>.
      </p>
    </LegalLayout>
  );
}
